import ServicesCard from "./ServicesCard";

const Services = () => {
  return (
    <div className="py-20 xl:py-28">
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative z-10">
        <ServicesCard />
      </div>
    </div>
  );
};

export default Services;
